import classnames from 'classnames';
import * as React from 'react';
import { analytics, createOpenSidebarFromRowEvent } from '@atlassian/temp-analytics';
import { useSidebar } from '../../hooks';
import { SidebarOptions } from '../../state/src/sidebar-slice';

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement> {
  sidebar: string;
  payload?: unknown;
  isSelected?: boolean;
  hasDefaultClassName?: boolean;
  sidebarOptions?: SidebarOptions;
}

const OpenSidebarRow = ({
  sidebar: sidebarType,
  payload,
  className,
  isSelected,
  children,
  hasDefaultClassName = true,
  sidebarOptions,
  ...tableRowProps
}: Props) => {
  const { openSidebar } = useSidebar();
  return (
    <tr
      {...(tableRowProps as React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement>)}
      className={
        hasDefaultClassName
          ? classnames(className, 'search-result', {
              'search-result-selected': isSelected,
            })
          : classnames(className)
      }
      onClick={() => {
        analytics.sendUIEvent(createOpenSidebarFromRowEvent(sidebarType));
        openSidebar({
          sidebarType,
          payload,
          sidebarOptions,
        });
      }}
    >
      {/* Pulling the render-ed out children to be more grokkable  */}
      {children}
    </tr>
  );
};

export default OpenSidebarRow;
